/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import resizing from '../../../../phase2/survey/context/resizing';
import WidgetEmbeddedNps from './sequence/WidgetEmbeddedNps';
import survey from '../../../../phase2/survey/context/survey';
import WidgetEmbeddedThanks from './sequence/WidgetEmbeddedThanks';
import { connector } from '../../../broadcast';

/**
 * 埋込 component - Nps / Thanks 作成します
 * - {@link WidgetEmbeddedNps}
 * - {@link WidgetEmbeddedThanks}
 * @param {*} nps Redux.store.nps
 * @param {*} submit Redux.store.submit
 * @param {*} state React.Context.survey.state
 * @param {boolean} desktop window.innerWidth `desktop` flag
 * @return {*} React.node
 * @constructor
 */
const WidgetEmbeddedSequence = ({ nps, submit, state, desktop }) => {
  return (
    <>
      <WidgetEmbeddedNps
        nps={nps}
        submit={submit}
        state={state}
        desktop={desktop}
      />
      <WidgetEmbeddedThanks state={state} submit={submit} desktop={desktop} />
    </>
  );
};

/**
 * 埋込 component を作成し Redux と接続します
 * @param {*} nps Redux.store.nps
 * @param {*} submit Redux.store.submit
 * @param {*} props React.props
 * @return {*} React.node {@link WidgetEmbeddedSequence}
 * @constructor
 */
const WidgetEmbeddedComponent = ({ nps, submit, ...props }) => {
  const resizingContext = useContext(resizing.Context);
  const { state, dispatch } = useContext(survey.Context);
  return (
    <WidgetEmbeddedSequence
      nps={nps}
      submit={submit}
      state={state}
      dispatch={dispatch}
      desktop={resizingContext.state.desktop}
      {...props}
    />
  );
};

// Redux
const WidgetEmbedded = connector(WidgetEmbeddedComponent);

export default WidgetEmbedded;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/page/widget/index.js